<template>
    <div class="purchase_part-subheader">
        <b-col class="d-flex align-items-center px-1" lg="3" sm="6" xs="12">
            <span v-if="purchase.type === 'fl44_unknown_volume'" class="fs-12 green-color">
                Цена контракта: <span class="fw-600 ws-nowrap">{{ $formatPrice(purchase.purchase_info.contract_price) }} руб.</span>
            </span>
            <span v-else class="fs-12 green-color">
                НЦК: <span class="fw-600 ws-nowrap">{{ $formatPrice(purchase.purchase_info.start_price) }} руб.</span>
            </span>
        </b-col>
        <template v-if="isPurchasePubliclyAvailable">
            <b-col class="d-flex align-items-center px-1" lg="3" sm="6" xs="12">
                <span class="fs-12 green-color">
                    Предложений:
                    <span v-if="purchase.flags.is_hidden" class="fw-600 ws-nowrap">&nbsp;Скрыто</span>
                    <span v-else class="fw-600 ws-nowrap">&nbsp;{{ purchase.type === 'fl44' ? purchase.purchase_info.purchase_actual_offers_count : purchase.purchase_info.purchase_actual_proposals_count }}</span>
                </span>
            </b-col>
            <template>
                <b-col class="d-flex align-items-center px-1" lg="3" sm="6" xs="12">
                    <span v-if="purchase.type === 'fl44'" class="fs-12 green-color">
                        Лучшее:
                        <span v-if="purchase.flags.is_hidden" class="fw-600 ws-nowrap">&nbsp;Скрыто</span>
                        <span v-else class="fw-600 ws-nowrap">&nbsp;{{ purchase.purchase_info.purchase_min_offer_cost ? $formatPrice(purchase.purchase_info.purchase_min_offer_cost) + ' руб.' : '&mdash;' }} </span>
                    </span>
                </b-col>
                <b-col class="d-flex align-items-center px-1" lg="3" sm="6" xs="12">
                    <span v-if="purchase.type === 'fl44'" class="fs-12 green-color">
                        Снижение:
                        <span v-if="purchase.flags.is_hidden" class="fw-600 ws-nowrap">&nbsp;Скрыто</span>
                        <span v-else class="fw-600 ws-nowrap">&nbsp;{{ purchase.purchase_info.economy_percentage ? purchase.purchase_info.economy_percentage + '%' : '&mdash;' }}</span>
                    </span>
                </b-col>
            </template>
        </template>
    </div>
</template>

<script>
export default {
    name: 'cabinet-fl44-contract-card-subheader',
    props: {
        purchase: {
            type: Object,
            required: true
        }
    },
    computed: {
        isPurchasePubliclyAvailable() {
            return !this.purchase.status.stage.includes('non_public');
        }
    }
};
</script>

<style scoped>
.purchase_part-subheader {
    background-color: #e4e6e8;
    padding: 4px 11px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -moz-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
</style>
